import React, { FC, memo, useState } from 'react';
import { ProductViewModel } from '~/lib/data-contract';
import { CMSLink, Typography } from '~/shared/components';
import { useTranslation } from '~/shared/utils';
import styles from './color-selector.module.css';
import clsx from 'clsx';
import { queries } from '~/theme';
import ProductImage from '~/shared/components/product-image/product-image.component';

export type Props = Pick<ProductViewModel, 'colors'> & { activeColorId?: string | null };

const  MAX_VISIBLE_COLORS = 9;

const ColorSelector: FC<Props> = memo((props) => {
    const { colors = [], activeColorId } = props;
    const [showAllColors, setShowAllColors] = useState(false);
    const { translate } = useTranslation();
    

    const selectedColor =
        colors?.find((color) => color.productColorId === activeColorId)?.color || '';

    return (
        <div>
            <Typography variant="caption" as="div" uppercase>
                {selectedColor &&
                    translate('productDetails.activeColorVariant', { activeColor: selectedColor })}
            </Typography>
            <nav className={styles.nav}>
                {colors.slice(0, showAllColors ? colors.length : MAX_VISIBLE_COLORS).map(({ image, productColorId, color, url }) => (
                    <CMSLink
                        key={productColorId}
                        href={url}
                        replace
                        title={color || ''}
                        className={clsx(styles.link, {
                            [styles.active]: productColorId === activeColorId,
                        })}
                    >
                        <ProductImage
                            className={styles.image}
                            sizes={`${queries.md} 80px, 48px`}
                            image={image}
                            width={48}
                            height={48}
                        />
                    </CMSLink>
                ))}
                {colors.length > MAX_VISIBLE_COLORS && !showAllColors && (
                    <button
                        className={styles.loadMoreButton}
                        onClick={() => setShowAllColors(true)}
                        aria-label={colors.length - MAX_VISIBLE_COLORS + ' more colors'}
                    >
                        +{colors.length - MAX_VISIBLE_COLORS}
                    </button>
                )}
            </nav>
        </div>
    );
});

ColorSelector.displayName = 'ColorSelector';
export default ColorSelector;
